import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, FormGroupDirective, Validators} from '@angular/forms';
import {TranslateService} from '@ngx-translate/core';
import { toggleEditMode } from '../../../../shared/utils';
import {IHvGebaeudetypDachung} from '../../../models/hvgebaeudetypdachung';
import {DataService} from '../../../service/data.service';

@Component({
  selector: 'app-gebaeudetyp-dach',
  templateUrl: './gebaeudetyp-dach.component.html',
  styleUrls: ['./gebaeudetyp-dach.component.scss']
})
export class GebaeudetypDachComponent implements OnInit, OnChanges {

  @Input()
  parentFormGroupDirective: FormGroupDirective;

  @Input()
  formGroup: UntypedFormGroup;

  @Input()
  showGroup = true;

  @Input()
  expertMode: boolean;

  constructor(public translateService: TranslateService, public dataService: DataService) { }

  static createFormGroup(fb: UntypedFormBuilder) {
    return fb.group({
      gebaeudetyp: new UntypedFormControl('', Validators.required),
      dachung: new UntypedFormControl('', Validators.required),
    });
  }

  ngOnInit(): void {
    this.toggleEditMode();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.showGroup && changes.showGroup.currentValue !== changes.showGroup.previousValue) {
      Promise.resolve().then(() => this.toggleEditMode());
    }
  }

  get Dachungen(){
    return this.dataService.hvDachungen;
  }

  get GebaeudeTypen(){
    return this.dataService.hvGebaeudeTypen;
  }

  get gebaeudetyp() { return this.formGroup.get('gebaeudetyp'); }
  get dachung() { return this.formGroup.get('dachung'); }

  toggleEditMode(): void {
    toggleEditMode(this.gebaeudetyp, this.showGroup);
    toggleEditMode(this.dachung, this.showGroup);
  }

  getDaten(): IHvGebaeudetypDachung {
    return this.showGroup ? {
      GebaeudetypId: this.gebaeudetyp.value,
      DachungId: this.dachung.value
    } : null;
  }

  setDaten(daten: IHvGebaeudetypDachung): void {
    if(daten) {
      this.gebaeudetyp.setValue(daten.GebaeudetypId);
      this.dachung.setValue(daten.DachungId);
    }
  }
}
